import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  activateAllPresetsFailure,
  //
  activateAllPresetsSuccess,
  addInspectionFromTemplateFailure,
  //
  addInspectionFromTemplateSuccess,
  addInspectionTemplateFailure,
  //
  addInspectionTemplateSuccess,
  addMaintenanceAssetFailure,
  //
  addMaintenanceAssetSuccess,
  addMaintenanceComplianceFailure,
  //
  addMaintenanceComplianceSuccess,
  addMaintenanceInvoiceFailure,
  //
  addMaintenanceInvoiceSuccess,
  deleteMaintenanceInvoiceFailure,
  deleteMaintenanceInvoiceSuccess,
  editMaintenanceInvoiceFailure,
  editMaintenanceInvoiceSuccess,
  addMaintenanceInspectionFailure,
  //
  addMaintenanceInspectionSuccess,
  addMaintenanceRequestFailure,
  //
  addMaintenanceRequestSuccess,
  addMaintenanceScheduleFailure,
  //
  addMaintenanceScheduleSuccess,
  cloneInspectionTemplateFailure,
  //
  cloneInspectionTemplateSuccess,
  deleteInspectionTemplateFailure,
  //
  deleteInspectionTemplateSuccess,
  deleteMaintenanceAssetFailure,
  //
  deleteMaintenanceAssetSuccess,
  deleteMaintenanceComplianceFailure,
  //
  deleteMaintenanceComplianceSuccess,
  deleteMaintenanceRequestFailure,
  //
  deleteMaintenanceRequestSuccess,
  deleteMaintenanceScheduleFailure,
  //
  deleteMaintenanceScheduleSuccess,
  acceptQuoteFailure,
  acceptQuoteSuccess,
  editInspectionTemplateFailure,
  //
  editInspectionTemplateSuccess,
  editMaintenanceAssetFailure,
  //
  editMaintenanceAssetSuccess,
  editMaintenanceComplianceFailure,
  //
  editMaintenanceComplianceSuccess,
  editMaintenanceRequestFailure,
  //
  editMaintenanceRequestSuccess,
  editMaintenanceScheduleFailure,
  //
  editMaintenanceScheduleSuccess,
  getMaintenanceScheduleFailure,
  getMaintenanceScheduleSuccess,
  fetchComplianceMatrixFailure,
  //
  fetchComplianceMatrixSuccess,
  fetchScheduledCompletedChecksReportFailure,
  fetchScheduledCompletedChecksReportSuccess,
  fetchMonthlyScheduleChecklistReportFailure,
  fetchMonthlyScheduleChecklistReportSuccess,
  exportMonthlyScheduleChecklistReportFailure,
  exportMonthlyScheduleChecklistReportSuccess,
  fetchWeeklyScheduleChecklistReportFailure,
  fetchWeeklyScheduleChecklistReportSuccess,
  exportWeeklyScheduleChecklistReportFailure,
  exportWeeklyScheduleChecklistReportSuccess,
  exportQuarterlyScheduleChecklistReportFailure,
  exportQuarterlyScheduleChecklistReportSuccess,
  exportAnnualScheduleChecklistReportFailure,
  exportAnnualScheduleChecklistReportSuccess,
  exportBiannualScheduleChecklistReportFailure,
  exportBiannualScheduleChecklistReportSuccess,
  fetchQuarterlyScheduleChecklistReportFailure,
  fetchQuarterlyScheduleChecklistReportSuccess,
  fetchAnnualScheduleChecklistReportFailure,
  fetchAnnualScheduleChecklistReportSuccess,
  fetchBiannualScheduleChecklistReportFailure,
  fetchBiannualScheduleChecklistReportSuccess,
  fetchDailyScheduleChecklistReportFailure,
  fetchDailyScheduleChecklistReportSuccess,
  fetchCqcReportFailure,
  //
  fetchCqcReportSuccess,
  fetchInspectionReportFailure,
  //
  fetchInspectionReportSuccess,
  fetchInspectionTemplatesFailure,
  //
  fetchInspectionTemplatesSuccess,
  fetchMaintenanceAssetFailure,
  fetchMaintenanceAssetsFailure,
  //
  fetchMaintenanceAssetsSuccess,
  //
  fetchMaintenanceAssetSuccess,
  fetchMaintenanceComplianceFailure,
  fetchMaintenanceComplianceItemFailure,
  //
  fetchMaintenanceComplianceItemSuccess,
  //
  fetchMaintenanceComplianceSuccess,
  fetchMaintenanceDashboardFailure,
  fetchMaintenanceDashboardSuccess,
  fetchMaintenanceInspectionFailure,
  fetchMaintenanceInspectionsFailure,
  //
  fetchMaintenanceInspectionsSuccess,
  //
  fetchMaintenanceInspectionSuccess,
  fetchMaintenanceLocationSettingFailure,
  //
  fetchMaintenanceLocationSettingSuccess,
  fetchMaintenanceRequestFailure,
  fetchMaintenanceRequestsFailure,
  //
  fetchMaintenanceRequestsSuccess,
  //
  fetchMaintenanceRequestSuccess,
  fetchMaintenanceSchedulesFailure,
  //
  fetchMaintenanceSchedulesSuccess,
  fetchQuoteFailure,
  fetchQuoteSuccess,
  fetchQuotesFailure,
  fetchQuotesSuccess,
  addQuoteFailure,
  addQuoteSuccess,
  editQuoteFailure,
  editQuoteSuccess,
  deleteQuoteFailure,
  deleteQuoteSuccess,
  saveMaintenanceLocationSettingFailure,
  //
  saveMaintenanceLocationSettingSuccess,
  submitMaintenanceInspectionFailure,
  //
  submitMaintenanceInspectionSuccess,
  updateMaintenanceRequestStatusFailure,
  //
  updateMaintenanceRequestStatusSuccess,
  //
  updateInspectionStatusFailure,
  updateInspectionStatusSuccess,
  approveInspectionFailure,
  approveInspectionSuccess,
  //
  skipInspectionItemsFailure,
  skipInspectionItemsSuccess,
  //
  editMaintenanceInspectionFailure,
  editMaintenanceInspectionSuccess,
} from "./actions";
import {
  ACTIVATE_ALL_PRESETS,
  ADD_INSPECTION_FROM_TEMPLATE,
  ADD_INSPECTION_TEMPLATE,
  ADD_MAINTENANCE_ASSET,
  ADD_MAINTENANCE_COMPLIANCE,
  ADD_MAINTENANCE_INVOICE,
  DELETE_MAINTENANCE_INVOICE,
  EDIT_MAINTENANCE_INVOICE,
  ADD_MAINTENANCE_INSPECTION,
  ADD_MAINTENANCE_REQUEST,
  ADD_MAINTENANCE_SCHEDULE,
  CLONE_INSPECTION_TEMPLATE,
  DELETE_INSPECTION_TEMPLATE,
  DELETE_MAINTENANCE_ASSET,
  DELETE_MAINTENANCE_COMPLIANCE,
  DELETE_MAINTENANCE_REQUEST,
  DELETE_MAINTENANCE_SCHEDULE,
  EDIT_INSPECTION_TEMPLATE,
  EDIT_MAINTENANCE_ASSET,
  EDIT_MAINTENANCE_COMPLIANCE,
  EDIT_MAINTENANCE_REQUEST,
  EDIT_MAINTENANCE_SCHEDULE,
  ACCEPT_MAINTENANCE_QUOTE,
  FETCH_COMPLIANCE_MATRIX,
  FETCH_CQC_REPORT,
  FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT,
  FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT,
  FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT,
  FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT,
  FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT,
  FETCH_BIANNUAL_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_BIANNUAL_SCHEDULE_CHECKLIST_REPORT,
  FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT,
  FETCH_INSPECTION_REPORT,
  FETCH_INSPECTION_TEMPLATES,
  FETCH_MAINTENANCE_ASSET,
  FETCH_MAINTENANCE_ASSETS,
  FETCH_MAINTENANCE_COMPLIANCE,
  FETCH_MAINTENANCE_COMPLIANCE_ITEM,
  FETCH_MAINTENANCE_DASHBOARD,
  FETCH_MAINTENANCE_INSPECTION,
  FETCH_MAINTENANCE_INSPECTIONS,
  FETCH_MAINTENANCE_LOCATION_SETTING,
  FETCH_MAINTENANCE_QUOTES,
  FETCH_MAINTENANCE_QUOTE,
  FETCH_MAINTENANCE_REQUEST,
  FETCH_MAINTENANCE_REQUESTS,
  FETCH_MAINTENANCE_SCHEDULES,
  GET_MAINTENANCE_SCHEDULE,
  ADD_MAINTENANCE_QUOTE,
  EDIT_MAINTENANCE_QUOTE,
  DELETE_MAINTENANCE_QUOTE,
  SAVE_MAINTENANCE_LOCATION_SETTING,
  SUBMIT_MAINTENANCE_INSPECTION,
  UPDATE_MAINTENANCE_REQUEST_STATUS,
  UPDATE_INSPECTION_STATUS,
  APPROVE_INSPECTION,
  SKIP_INSPECTION_ITEMS,
  EDIT_MAINTENANCE_INSPECTION,
} from "./constants";

export function* fetchMaintenanceDashboardSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-dashboard?${query}`,
    );
    yield put(fetchMaintenanceDashboardSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceDashboardFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch dashboard"));
  }
}

export function* fetchMaintenanceRequestsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-request?${query}`,
    );
    yield put(fetchMaintenanceRequestsSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceRequestsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch requests"));
  }
}

export function* addMaintenanceRequestSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-request/add`,
      payload,
    );
    if (response) {
      yield put(addMaintenanceRequestSuccess());
      yield put(successAlert("Request created successfully"));
      if (typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(addMaintenanceRequestFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else
      yield put(
        errorAlert(e?.response?.data?.message || "Failed to create request"),
      );
  }
}

export function* fetchMaintenanceRequestSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-request/${payload}`,
    );
    yield put(fetchMaintenanceRequestSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceRequestFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch request"));
  }
}

export function* editMaintenanceRequestSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, id, onSuccess } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-request/edit/${id}`,
      data,
    );
    if (response) {
      yield put(editMaintenanceRequestSuccess());
      yield put(successAlert("Request updated successfully"));
      if (history) history.push("/d/maintenance/requests");
      if (typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(editMaintenanceRequestFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else
      yield put(
        errorAlert(e?.response?.data?.message || "Failed to update request"),
      );
  }
}

export function* deleteMaintenanceRequestSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/maintenance-request/${payload?.id}`,
    );
    if (data) {
      yield put(deleteMaintenanceRequestSuccess());
      yield put(successAlert("Request deleted successfully"));
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteMaintenanceRequestFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to delete request"));
  }
}

export function* updateMaintenanceRequestStatusSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-request/status/${payload?.id}`,
      payload?.data,
    );
    if (response) {
      yield put(updateMaintenanceRequestStatusSuccess());
      yield put(successAlert("Status updated successfully"));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(updateMaintenanceRequestStatusFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update status"));
  }
}

export function* fetchMaintenanceInspectionsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-inspection?${query}`,
    );
    yield put(fetchMaintenanceInspectionsSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceInspectionsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch inspections"));
  }
}

export function* addMaintenanceInspectionSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection/add`,
      data,
    );
    if (response) {
      yield put(addMaintenanceInspectionSuccess());
      yield put(successAlert("Inspection created successfully"));
      if (history) history.push("/d/maintenance/inspections");
    }
  } catch (e) {
    yield put(addMaintenanceInspectionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to create inspection"));
  }
}

export function* fetchMaintenanceInspectionSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-inspection/${payload}`,
    );
    yield put(fetchMaintenanceInspectionSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceInspectionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch inspection"));
  }
}

export function* submitMaintenanceInspectionSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, id } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection/submit/${id}`,
      data,
    );
    if (response) {
      yield put(submitMaintenanceInspectionSuccess());
      yield put(successAlert("Inspection submitted successfully"));
      if (history) history.push("/d/maintenance/inspections");
    }
  } catch (e) {
    yield put(submitMaintenanceInspectionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to submit inspection"));
  }
}

export function* fetchMaintenanceAssetsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-asset?${query}`,
    );
    const result = Array.isArray(data)
      ? { data, total: data.length, current_page: payload?.page ?? 1 }
      : { ...data, current_page: payload?.page ?? data?.current_page ?? 1 };
    yield put(fetchMaintenanceAssetsSuccess(result));
  } catch (e) {
    yield put(fetchMaintenanceAssetsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch assets"));
  }
}

export function* addMaintenanceAssetSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, onSuccess } = payload || {};
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-asset/add`,
      data,
    );
    if (response) {
      yield put(addMaintenanceAssetSuccess());
      yield put(successAlert("Asset created successfully"));
      if (typeof onSuccess === "function") onSuccess();
      else if (history) history.push("/d/maintenance/assets");
    }
  } catch (e) {
    yield put(addMaintenanceAssetFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to create asset"));
  }
}

export function* fetchMaintenanceAssetSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const id =
    typeof payload === "string" ? payload : (payload?.uuid ?? payload?.id);
  try {
    const { data } = yield call(api(token).get, `/api/maintenance-asset/${id}`);
    yield put(fetchMaintenanceAssetSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceAssetFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch asset"));
  }
}

export function* editMaintenanceAssetSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, id, uuid, onSuccess } = payload || {};
  const assetId = id ?? uuid;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-asset/edit/${assetId}`,
      data,
    );
    if (response) {
      yield put(editMaintenanceAssetSuccess());
      yield put(successAlert("Asset updated successfully"));
      if (typeof onSuccess === "function") onSuccess();
      else if (history) history.push("/d/maintenance/assets");
    }
  } catch (e) {
    yield put(editMaintenanceAssetFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update asset"));
  }
}

export function* deleteMaintenanceAssetSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const id = payload?.id ?? payload?.uuid;
  try {
    const data = yield call(api(token).delete, `/api/maintenance-asset/${id}`);
    if (data) {
      yield put(deleteMaintenanceAssetSuccess());
      yield put(successAlert("Asset deleted successfully"));
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteMaintenanceAssetFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to delete asset"));
  }
}

// Quotes
export function* fetchQuotesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-quote?${query}`,
    );
    const result = Array.isArray(data)
      ? { data, total: data.length, current_page: payload?.page ?? 1 }
      : { ...data, current_page: payload?.page ?? data?.current_page ?? 1 };
    yield put(fetchQuotesSuccess(result));
  } catch (e) {
    yield put(fetchQuotesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch quotes"));
  }
}

export function* fetchQuoteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const id =
    typeof payload === "string" ? payload : (payload?.uuid ?? payload?.id);
  try {
    const { data } = yield call(api(token).get, `/api/maintenance-quote/${id}`);
    yield put(fetchQuoteSuccess(data));
  } catch (e) {
    yield put(fetchQuoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch quote"));
  }
}

export function* addQuoteSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-quote/add`,
      payload,
    );
    if (response) {
      yield put(addQuoteSuccess());
      yield put(successAlert("Quote created successfully"));
      if (typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(addQuoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to create quote"));
  }
}

export function* editQuoteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, id, uuid, onSuccess } = payload || {};
  const quoteId = id ?? uuid;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-quote/edit/${quoteId}`,
      data,
    );
    if (response) {
      yield put(editQuoteSuccess());
      yield put(successAlert("Quote updated successfully"));
      if (typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(editQuoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update quote"));
  }
}

export function* deleteQuoteSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const id = payload?.id ?? payload?.uuid;
  try {
    const data = yield call(api(token).delete, `/api/maintenance-quote/${id}`);
    if (data) {
      yield put(deleteQuoteSuccess());
      yield put(successAlert("Quote deleted successfully"));
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteQuoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to delete quote"));
  }
}

export function* acceptQuoteSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const maintenanceRequestId =
    payload?.maintenance_request_id ??
    payload?.maintenanceRequestId ??
    payload?.request_id;
  const approvedQuoteId =
    payload?.approved_quote_id ?? payload?.quote_id ?? payload?.id;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-request-accept/${maintenanceRequestId}`,
      { approved_quote_id: approvedQuoteId },
    );
    if (response) {
      yield put(acceptQuoteSuccess());
      yield put(successAlert("Quote accepted successfully"));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(acceptQuoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to accept quote"));
  }
}

export function* fetchMaintenanceComplianceSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  const requestedPage = payload?.page ?? 1;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-compliance?${query}`,
    );
    const body = Array.isArray(data)
      ? {
          data,
          total: data.length,
          current_page: requestedPage,
        }
      : {
          ...data,
          current_page: data?.current_page ?? requestedPage,
        };
    yield put(fetchMaintenanceComplianceSuccess(body));
  } catch (e) {
    yield put(fetchMaintenanceComplianceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch compliance certificates"));
  }
}

export function* addMaintenanceComplianceSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const history = payload?.history;
  const onSuccess = payload?.onSuccess;
  let data = payload?.data;
  if (data === undefined && payload && typeof payload === "object") {
    const next = { ...payload };
    delete next.history;
    delete next.onSuccess;
    delete next.data;
    data = next;
  }
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-compliance/add`,
      data,
    );
    if (response) {
      yield put(addMaintenanceComplianceSuccess());
      yield put(successAlert("Certificate added successfully"));
      if (history) history.push("/d/maintenance/certificates");
      if (typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(addMaintenanceComplianceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to add certificate"));
  }
}

export function* addMaintenanceInvoiceSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const onSuccess = payload?.onSuccess;
  let data = payload?.data;
  if (data === undefined && payload && typeof payload === "object") {
    const next = { ...payload };
    delete next.onSuccess;
    delete next.data;
    data = next;
  }
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-invoice/add`,
      data,
    );
    if (response) {
      yield put(addMaintenanceInvoiceSuccess());
      yield put(successAlert("Invoice added successfully"));
      if (typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(addMaintenanceInvoiceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to add invoice"));
  }
}

export function* editMaintenanceInvoiceSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const onSuccess = payload?.onSuccess;
  const id = payload?.id ?? payload?.uuid;
  let data = payload?.data;
  if (data === undefined && payload && typeof payload === "object") {
    const next = { ...payload };
    delete next.onSuccess;
    delete next.data;
    delete next.id;
    delete next.uuid;
    data = next;
  }
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-invoice/edit/${id}`,
      data,
    );
    if (response) {
      yield put(editMaintenanceInvoiceSuccess());
      yield put(successAlert("Invoice updated successfully"));
      if (typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(editMaintenanceInvoiceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update invoice"));
  }
}

export function* deleteMaintenanceInvoiceSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const id = payload?.id ?? payload?.uuid;
  try {
    const data = yield call(
      api(token).delete,
      `/api/maintenance-invoice/${id}`,
    );
    if (data) {
      yield put(deleteMaintenanceInvoiceSuccess());
      yield put(successAlert("Invoice deleted successfully"));
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteMaintenanceInvoiceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to delete invoice"));
  }
}

export function* fetchMaintenanceComplianceItemSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const id = typeof payload === "string" ? payload : payload?.uuid;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-compliance/${id}`,
    );
    yield put(fetchMaintenanceComplianceItemSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceComplianceItemFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch certificate"));
  }
}

export function* editMaintenanceComplianceSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const history = payload?.history;
  const onSuccess = payload?.onSuccess;
  let id = payload?.id ?? payload?.uuid;
  let data = payload?.data;
  if (data === undefined && payload && typeof payload === "object") {
    const rest = { ...payload };
    delete rest.history;
    delete rest.onSuccess;
    delete rest.data;
    delete rest.id;
    const uuid = rest.uuid;
    delete rest.uuid;
    id = id ?? uuid;
    data = rest;
  }
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-compliance/edit/${id}`,
      data,
    );
    if (response) {
      yield put(editMaintenanceComplianceSuccess());
      yield put(successAlert("Certificate updated successfully"));
      if (history) history.push("/d/maintenance/certificates");
      if (typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(editMaintenanceComplianceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update certificate"));
  }
}

export function* deleteMaintenanceComplianceSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const complianceId = payload?.id ?? payload?.uuid;
  try {
    const data = yield call(
      api(token).delete,
      `/api/maintenance-compliance/${complianceId}`,
    );
    if (data) {
      yield put(deleteMaintenanceComplianceSuccess());
      yield put(successAlert("Certificate deleted successfully"));
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteMaintenanceComplianceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to delete certificate"));
  }
}

export function* fetchMaintenanceSchedulesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-schedule?${query}`,
    );
    yield put(fetchMaintenanceSchedulesSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceSchedulesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch schedules"));
  }
}

export function* getMaintenanceScheduleSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const scheduleId = payload?.id ?? payload?.uuid ?? payload;

  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-schedule/${scheduleId}`,
    );
    yield put(getMaintenanceScheduleSuccess(data));
  } catch (e) {
    yield put(getMaintenanceScheduleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch schedule"));
  }
}

export function* addMaintenanceScheduleSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, onSuccess } = payload || {};
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-schedule/add`,
      data,
    );
    if (response) {
      yield put(addMaintenanceScheduleSuccess());
      yield put(successAlert("Schedule created successfully"));
      if (onSuccess && typeof onSuccess === "function") onSuccess();
      if (history) history.push("/d/maintenance/schedule");
    }
  } catch (e) {
    yield put(addMaintenanceScheduleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to create schedule"));
  }
}

export function* editMaintenanceScheduleSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, id, onSuccess } = payload || {};
  const scheduleId = id ?? payload?.uuid;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-schedule/edit/${scheduleId}`,
      data,
    );
    if (response) {
      yield put(editMaintenanceScheduleSuccess());
      yield put(successAlert("Schedule updated successfully"));
      if (onSuccess && typeof onSuccess === "function") onSuccess();
      if (history) history.push("/d/maintenance/schedule");
    }
  } catch (e) {
    yield put(editMaintenanceScheduleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update schedule"));
  }
}

export function* deleteMaintenanceScheduleSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const id = payload?.id ?? payload?.uuid;
  try {
    const data = yield call(
      api(token).delete,
      `/api/maintenance-schedule/${id}`,
    );
    if (data) {
      yield put(deleteMaintenanceScheduleSuccess());
      yield put(successAlert("Schedule deleted successfully"));
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteMaintenanceScheduleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to delete schedule"));
  }
}

export function* activateAllPresetsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-schedule/activate-presets`,
      payload,
    );
    if (response) {
      yield put(activateAllPresetsSuccess());
      yield put(successAlert("Presets activated successfully"));
    }
  } catch (e) {
    yield put(activateAllPresetsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to activate presets"));
  }
}

export function* fetchMaintenanceLocationSettingSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-location-setting/${payload?.location_id}`,
    );
    yield put(fetchMaintenanceLocationSettingSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceLocationSettingFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch location settings"));
  }
}

export function* saveMaintenanceLocationSettingSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/maintenance-location-setting/add`,
      payload,
    );
    yield put(saveMaintenanceLocationSettingSuccess(data));
    yield put(successAlert("Settings saved successfully"));
  } catch (e) {
    yield put(saveMaintenanceLocationSettingFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to save settings"));
  }
}

export function* fetchInspectionTemplatesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-inspection-template?${query}`,
    );
    yield put(fetchInspectionTemplatesSuccess(data));
  } catch (e) {
    yield put(fetchInspectionTemplatesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch inspection templates"));
  }
}

export function* addInspectionTemplateSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, onSuccess } = payload || {};
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection-template/add`,
      data,
    );
    if (response) {
      yield put(addInspectionTemplateSuccess());
      yield put(successAlert("Template created successfully"));
      if (history) history.push("/d/maintenance/inspection/templates");
      if (onSuccess && typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(addInspectionTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to create template"));
  }
}

export function* editInspectionTemplateSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, id, onSuccess } = payload || {};
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection-template/edit/${id}`,
      data,
    );
    if (response) {
      yield put(editInspectionTemplateSuccess());
      yield put(successAlert("Template updated successfully"));
      if (history) history.push("/d/maintenance/inspection/templates");
      if (onSuccess && typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(editInspectionTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update template"));
  }
}

export function* deleteInspectionTemplateSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/maintenance-inspection-template/${payload?.id}`,
    );
    if (data) {
      yield put(deleteInspectionTemplateSuccess());
      yield put(successAlert("Template deleted successfully"));
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteInspectionTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to delete template"));
  }
}

export function* cloneInspectionTemplateSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, onSuccess } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection-template/clone/${data?.id}`,
      data,
    );
    if (response) {
      yield put(cloneInspectionTemplateSuccess());
      yield put(successAlert("Template cloned successfully"));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(cloneInspectionTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to clone template"));
  }
}

export function* addInspectionFromTemplateSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, onSuccess } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection/add-from-template`,
      data,
    );
    if (response) {
      yield put(addInspectionFromTemplateSuccess());
      yield put(successAlert("Inspection created from template successfully"));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(addInspectionFromTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to create inspection from template"));
  }
}

export function* fetchMaintenanceDashboardFlow() {
  yield takeEvery(FETCH_MAINTENANCE_DASHBOARD, fetchMaintenanceDashboardSaga);
}
export function* fetchMaintenanceRequestsFlow() {
  yield takeEvery(FETCH_MAINTENANCE_REQUESTS, fetchMaintenanceRequestsSaga);
}
export function* addMaintenanceRequestFlow() {
  yield takeEvery(ADD_MAINTENANCE_REQUEST, addMaintenanceRequestSaga);
}
export function* fetchMaintenanceRequestFlow() {
  yield takeEvery(FETCH_MAINTENANCE_REQUEST, fetchMaintenanceRequestSaga);
}
export function* editMaintenanceRequestFlow() {
  yield takeEvery(EDIT_MAINTENANCE_REQUEST, editMaintenanceRequestSaga);
}
export function* deleteMaintenanceRequestFlow() {
  yield takeEvery(DELETE_MAINTENANCE_REQUEST, deleteMaintenanceRequestSaga);
}
export function* updateMaintenanceRequestStatusFlow() {
  yield takeEvery(
    UPDATE_MAINTENANCE_REQUEST_STATUS,
    updateMaintenanceRequestStatusSaga,
  );
}
export function* fetchMaintenanceInspectionsFlow() {
  yield takeEvery(
    FETCH_MAINTENANCE_INSPECTIONS,
    fetchMaintenanceInspectionsSaga,
  );
}
export function* addMaintenanceInspectionFlow() {
  yield takeEvery(ADD_MAINTENANCE_INSPECTION, addMaintenanceInspectionSaga);
}
export function* fetchMaintenanceInspectionFlow() {
  yield takeEvery(FETCH_MAINTENANCE_INSPECTION, fetchMaintenanceInspectionSaga);
}
export function* submitMaintenanceInspectionFlow() {
  yield takeEvery(
    SUBMIT_MAINTENANCE_INSPECTION,
    submitMaintenanceInspectionSaga,
  );
}
export function* fetchMaintenanceAssetsFlow() {
  yield takeEvery(FETCH_MAINTENANCE_ASSETS, fetchMaintenanceAssetsSaga);
}
export function* addMaintenanceAssetFlow() {
  yield takeEvery(ADD_MAINTENANCE_ASSET, addMaintenanceAssetSaga);
}
export function* fetchMaintenanceAssetFlow() {
  yield takeEvery(FETCH_MAINTENANCE_ASSET, fetchMaintenanceAssetSaga);
}
export function* editMaintenanceAssetFlow() {
  yield takeEvery(EDIT_MAINTENANCE_ASSET, editMaintenanceAssetSaga);
}
export function* deleteMaintenanceAssetFlow() {
  yield takeEvery(DELETE_MAINTENANCE_ASSET, deleteMaintenanceAssetSaga);
}

export function* fetchQuotesFlow() {
  yield takeEvery(FETCH_MAINTENANCE_QUOTES, fetchQuotesSaga);
}
export function* fetchQuoteFlow() {
  yield takeEvery(FETCH_MAINTENANCE_QUOTE, fetchQuoteSaga);
}
export function* addQuoteFlow() {
  yield takeEvery(ADD_MAINTENANCE_QUOTE, addQuoteSaga);
}
export function* editQuoteFlow() {
  yield takeEvery(EDIT_MAINTENANCE_QUOTE, editQuoteSaga);
}
export function* deleteQuoteFlow() {
  yield takeEvery(DELETE_MAINTENANCE_QUOTE, deleteQuoteSaga);
}
export function* acceptQuoteFlow() {
  yield takeEvery(ACCEPT_MAINTENANCE_QUOTE, acceptQuoteSaga);
}
export function* fetchMaintenanceComplianceFlow() {
  yield takeEvery(FETCH_MAINTENANCE_COMPLIANCE, fetchMaintenanceComplianceSaga);
}
export function* addMaintenanceComplianceFlow() {
  yield takeEvery(ADD_MAINTENANCE_COMPLIANCE, addMaintenanceComplianceSaga);
}
export function* addMaintenanceInvoiceFlow() {
  yield takeEvery(ADD_MAINTENANCE_INVOICE, addMaintenanceInvoiceSaga);
}
export function* editMaintenanceInvoiceFlow() {
  yield takeEvery(EDIT_MAINTENANCE_INVOICE, editMaintenanceInvoiceSaga);
}
export function* deleteMaintenanceInvoiceFlow() {
  yield takeEvery(DELETE_MAINTENANCE_INVOICE, deleteMaintenanceInvoiceSaga);
}
export function* fetchMaintenanceComplianceItemFlow() {
  yield takeEvery(
    FETCH_MAINTENANCE_COMPLIANCE_ITEM,
    fetchMaintenanceComplianceItemSaga,
  );
}
export function* editMaintenanceComplianceFlow() {
  yield takeEvery(EDIT_MAINTENANCE_COMPLIANCE, editMaintenanceComplianceSaga);
}
export function* deleteMaintenanceComplianceFlow() {
  yield takeEvery(
    DELETE_MAINTENANCE_COMPLIANCE,
    deleteMaintenanceComplianceSaga,
  );
}
export function* fetchMaintenanceSchedulesFlow() {
  yield takeEvery(FETCH_MAINTENANCE_SCHEDULES, fetchMaintenanceSchedulesSaga);
}
export function* addMaintenanceScheduleFlow() {
  yield takeEvery(ADD_MAINTENANCE_SCHEDULE, addMaintenanceScheduleSaga);
}
export function* editMaintenanceScheduleFlow() {
  yield takeEvery(EDIT_MAINTENANCE_SCHEDULE, editMaintenanceScheduleSaga);
}
export function* deleteMaintenanceScheduleFlow() {
  yield takeEvery(DELETE_MAINTENANCE_SCHEDULE, deleteMaintenanceScheduleSaga);
}
export function* getMaintenanceScheduleFlow() {
  yield takeEvery(GET_MAINTENANCE_SCHEDULE, getMaintenanceScheduleSaga);
}
export function* activateAllPresetsFlow() {
  yield takeEvery(ACTIVATE_ALL_PRESETS, activateAllPresetsSaga);
}
export function* fetchMaintenanceLocationSettingFlow() {
  yield takeEvery(
    FETCH_MAINTENANCE_LOCATION_SETTING,
    fetchMaintenanceLocationSettingSaga,
  );
}
export function* saveMaintenanceLocationSettingFlow() {
  yield takeEvery(
    SAVE_MAINTENANCE_LOCATION_SETTING,
    saveMaintenanceLocationSettingSaga,
  );
}
export function* fetchInspectionTemplatesFlow() {
  yield takeEvery(FETCH_INSPECTION_TEMPLATES, fetchInspectionTemplatesSaga);
}
export function* addInspectionTemplateFlow() {
  yield takeEvery(ADD_INSPECTION_TEMPLATE, addInspectionTemplateSaga);
}
export function* editInspectionTemplateFlow() {
  yield takeEvery(EDIT_INSPECTION_TEMPLATE, editInspectionTemplateSaga);
}
export function* deleteInspectionTemplateFlow() {
  yield takeEvery(DELETE_INSPECTION_TEMPLATE, deleteInspectionTemplateSaga);
}
export function* cloneInspectionTemplateFlow() {
  yield takeEvery(CLONE_INSPECTION_TEMPLATE, cloneInspectionTemplateSaga);
}
export function* addInspectionFromTemplateFlow() {
  yield takeEvery(ADD_INSPECTION_FROM_TEMPLATE, addInspectionFromTemplateSaga);
}

export function* fetchCqcReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-report/cqc?${query}`,
    );
    yield put(fetchCqcReportSuccess(data));
  } catch (e) {
    yield put(fetchCqcReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch CQC report"));
  }
}

export function* fetchComplianceMatrixSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-report/compliance-matrix?${query}`,
    );
    yield put(fetchComplianceMatrixSuccess(data));
  } catch (e) {
    yield put(fetchComplianceMatrixFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch compliance matrix"));
  }
}

export function* fetchScheduledCompletedChecksReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-report/scheduled-vs-completed-checks?${query}`,
    );
    yield put(fetchScheduledCompletedChecksReportSuccess(data));
  } catch (e) {
    yield put(fetchScheduledCompletedChecksReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch scheduled vs completed report"));
  }
}

export function* fetchMonthlyScheduleChecklistReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-report/monthly-schedule-checklist?${query}`,
    );
    yield put(fetchMonthlyScheduleChecklistReportSuccess(data));
  } catch (e) {
    yield put(fetchMonthlyScheduleChecklistReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch monthly checklist report"));
  }
}

export function* fetchWeeklyScheduleChecklistReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-report/weekly-schedule-checklist?${query}`,
    );
    yield put(fetchWeeklyScheduleChecklistReportSuccess(data));
  } catch (e) {
    yield put(fetchWeeklyScheduleChecklistReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch weekly checklist report"));
  }
}

export function* fetchQuarterlyScheduleChecklistReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-report/quarterly-schedule-checklist?${query}`,
    );
    yield put(fetchQuarterlyScheduleChecklistReportSuccess(data));
  } catch (e) {
    yield put(fetchQuarterlyScheduleChecklistReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch quarterly checklist report"));
  }
}

export function* fetchAnnualScheduleChecklistReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-report/annual-schedule-checklist?${query}`,
    );
    yield put(fetchAnnualScheduleChecklistReportSuccess(data));
  } catch (e) {
    yield put(fetchAnnualScheduleChecklistReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch annual checklist report"));
  }
}

export function* exportMonthlyScheduleChecklistReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const data = yield call(
      api(token, null, false, true).get,
      `/api/maintenance-report/export/monthly?${query}`,
    );
    if (data) {
      yield put(exportMonthlyScheduleChecklistReportSuccess());
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "monthly-checklist-report.pdf");
      document.body.appendChild(link);
      link.click();
    }
  } catch (e) {
    yield put(exportMonthlyScheduleChecklistReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to export monthly checklist report"));
  }
}

export function* exportWeeklyScheduleChecklistReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const data = yield call(
      api(token, null, false, true).get,
      `/api/maintenance-report/export/weekly?${query}`,
    );
    if (data) {
      yield put(exportWeeklyScheduleChecklistReportSuccess());
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "weekly-checklist-report.pdf");
      document.body.appendChild(link);
      link.click();
    }
  } catch (e) {
    yield put(exportWeeklyScheduleChecklistReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to export weekly checklist report"));
  }
}

export function* exportQuarterlyScheduleChecklistReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const data = yield call(
      api(token, null, false, true).get,
      `/api/maintenance-report/export/quarterly?${query}`,
    );
    if (data) {
      yield put(exportQuarterlyScheduleChecklistReportSuccess());
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "quarterly-checklist-report.pdf");
      document.body.appendChild(link);
      link.click();
    }
  } catch (e) {
    yield put(exportQuarterlyScheduleChecklistReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to export quarterly checklist report"));
  }
}

export function* exportAnnualScheduleChecklistReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const data = yield call(
      api(token, null, false, true).get,
      `/api/maintenance-report/export/annual?${query}`,
    );
    if (data) {
      yield put(exportAnnualScheduleChecklistReportSuccess());
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "annual-checklist-report.pdf");
      document.body.appendChild(link);
      link.click();
    }
  } catch (e) {
    yield put(exportAnnualScheduleChecklistReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to export annual checklist report"));
  }
}

export function* fetchBiannualScheduleChecklistReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-report/biannual-schedule-checklist?${query}`,
    );
    yield put(fetchBiannualScheduleChecklistReportSuccess(data));
  } catch (e) {
    yield put(fetchBiannualScheduleChecklistReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch biannual checklist report"));
  }
}

export function* exportBiannualScheduleChecklistReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const data = yield call(
      api(token, null, false, true).get,
      `/api/maintenance-report/export/biannual?${query}`,
    );
    if (data) {
      yield put(exportBiannualScheduleChecklistReportSuccess());
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "biannual-checklist-report.pdf");
      document.body.appendChild(link);
      link.click();
    }
  } catch (e) {
    yield put(exportBiannualScheduleChecklistReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to export biannual checklist report"));
  }
}

export function* fetchDailyScheduleChecklistReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-report/daily-schedule-checklist?${query}`,
    );
    yield put(fetchDailyScheduleChecklistReportSuccess(data));
  } catch (e) {
    yield put(fetchDailyScheduleChecklistReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch daily checklist report"));
  }
}

export function* fetchCqcReportFlow() {
  yield takeEvery(FETCH_CQC_REPORT, fetchCqcReportSaga);
}

export function* fetchInspectionReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id } = payload;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-inspection/${id}/report`,
    );
    yield put(fetchInspectionReportSuccess(data));
  } catch (e) {
    yield put(fetchInspectionReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch inspection report"));
  }
}

export function* fetchInspectionReportFlow() {
  yield takeEvery(FETCH_INSPECTION_REPORT, fetchInspectionReportSaga);
}

export function* fetchComplianceMatrixFlow() {
  yield takeEvery(FETCH_COMPLIANCE_MATRIX, fetchComplianceMatrixSaga);
}

export function* fetchScheduledCompletedChecksReportFlow() {
  yield takeEvery(
    FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT,
    fetchScheduledCompletedChecksReportSaga,
  );
}

export function* fetchMonthlyScheduleChecklistReportFlow() {
  yield takeEvery(
    FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT,
    fetchMonthlyScheduleChecklistReportSaga,
  );
}

export function* fetchWeeklyScheduleChecklistReportFlow() {
  yield takeEvery(
    FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT,
    fetchWeeklyScheduleChecklistReportSaga,
  );
}

export function* fetchQuarterlyScheduleChecklistReportFlow() {
  yield takeEvery(
    FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT,
    fetchQuarterlyScheduleChecklistReportSaga,
  );
}

export function* fetchAnnualScheduleChecklistReportFlow() {
  yield takeEvery(
    FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT,
    fetchAnnualScheduleChecklistReportSaga,
  );
}

export function* fetchBiannualScheduleChecklistReportFlow() {
  yield takeEvery(
    FETCH_BIANNUAL_SCHEDULE_CHECKLIST_REPORT,
    fetchBiannualScheduleChecklistReportSaga,
  );
}

export function* exportMonthlyScheduleChecklistReportFlow() {
  yield takeEvery(
    EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT,
    exportMonthlyScheduleChecklistReportSaga,
  );
}

export function* exportWeeklyScheduleChecklistReportFlow() {
  yield takeEvery(
    EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT,
    exportWeeklyScheduleChecklistReportSaga,
  );
}

export function* exportQuarterlyScheduleChecklistReportFlow() {
  yield takeEvery(
    EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT,
    exportQuarterlyScheduleChecklistReportSaga,
  );
}

export function* exportAnnualScheduleChecklistReportFlow() {
  yield takeEvery(
    EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT,
    exportAnnualScheduleChecklistReportSaga,
  );
}

export function* exportBiannualScheduleChecklistReportFlow() {
  yield takeEvery(
    EXPORT_BIANNUAL_SCHEDULE_CHECKLIST_REPORT,
    exportBiannualScheduleChecklistReportSaga,
  );
}

export function* fetchDailyScheduleChecklistReportFlow() {
  yield takeEvery(
    FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT,
    fetchDailyScheduleChecklistReportSaga,
  );
}

export function* updateInspectionStatusSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection/status/${payload?.id}`,
      payload?.data,
    );
    if (response) {
      yield put(updateInspectionStatusSuccess());
      yield put(successAlert("Inspection status updated successfully"));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(updateInspectionStatusFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update inspection status"));
  }
}

export function* updateInspectionStatusFlow() {
  yield takeEvery(UPDATE_INSPECTION_STATUS, updateInspectionStatusSaga);
}

export function* approveInspectionSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, data } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection/approve/${id}`,
      data,
    );
    if (response) {
      yield put(approveInspectionSuccess());
      yield put(successAlert("Inspection approved successfully"));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(approveInspectionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else
      yield put(
        errorAlert(
          e?.response?.data?.message || "Failed to approve inspection",
        ),
      );
  }
}

export function* approveInspectionFlow() {
  yield takeEvery(APPROVE_INSPECTION, approveInspectionSaga);
}

export function* skipInspectionItemsSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection/items/skip/${payload?.inspectionId}`,
      payload?.data,
    );
    if (response) {
      yield put(skipInspectionItemsSuccess());
      yield put(successAlert("Inspection items updated successfully"));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(skipInspectionItemsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else
      yield put(
        errorAlert(
          e?.response?.data?.message || "Failed to update inspection items",
        ),
      );
  }
}

export function* skipInspectionItemsFlow() {
  yield takeEvery(SKIP_INSPECTION_ITEMS, skipInspectionItemsSaga);
}

export function* editMaintenanceInspectionSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { id, data } = payload;
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection/edit/${id}`,
      data,
    );
    if (response) {
      yield put(editMaintenanceInspectionSuccess());
      yield put(successAlert("Inspection updated successfully"));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(editMaintenanceInspectionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else
      yield put(
        errorAlert(e?.response?.data?.message || "Failed to update inspection"),
      );
  }
}

export function* editMaintenanceInspectionFlow() {
  yield takeEvery(EDIT_MAINTENANCE_INSPECTION, editMaintenanceInspectionSaga);
}

export default function* MaintenanceSaga() {
  yield all([
    fetchMaintenanceDashboardFlow(),
    fetchMaintenanceRequestsFlow(),
    addMaintenanceRequestFlow(),
    fetchMaintenanceRequestFlow(),
    editMaintenanceRequestFlow(),
    deleteMaintenanceRequestFlow(),
    updateMaintenanceRequestStatusFlow(),
    fetchMaintenanceInspectionsFlow(),
    addMaintenanceInspectionFlow(),
    fetchMaintenanceInspectionFlow(),
    submitMaintenanceInspectionFlow(),
    fetchMaintenanceAssetsFlow(),
    addMaintenanceAssetFlow(),
    fetchMaintenanceAssetFlow(),
    editMaintenanceAssetFlow(),
    deleteMaintenanceAssetFlow(),
    fetchQuotesFlow(),
    fetchQuoteFlow(),
    addQuoteFlow(),
    editQuoteFlow(),
    deleteQuoteFlow(),
    acceptQuoteFlow(),
    fetchMaintenanceComplianceFlow(),
    addMaintenanceComplianceFlow(),
    addMaintenanceInvoiceFlow(),
    editMaintenanceInvoiceFlow(),
    deleteMaintenanceInvoiceFlow(),
    fetchMaintenanceComplianceItemFlow(),
    editMaintenanceComplianceFlow(),
    deleteMaintenanceComplianceFlow(),
    fetchMaintenanceSchedulesFlow(),
    addMaintenanceScheduleFlow(),
    editMaintenanceScheduleFlow(),
    deleteMaintenanceScheduleFlow(),
    getMaintenanceScheduleFlow(),
    activateAllPresetsFlow(),
    fetchMaintenanceLocationSettingFlow(),
    saveMaintenanceLocationSettingFlow(),
    fetchInspectionTemplatesFlow(),
    addInspectionTemplateFlow(),
    editInspectionTemplateFlow(),
    deleteInspectionTemplateFlow(),
    cloneInspectionTemplateFlow(),
    addInspectionFromTemplateFlow(),
    fetchCqcReportFlow(),
    fetchInspectionReportFlow(),
    fetchComplianceMatrixFlow(),
    fetchScheduledCompletedChecksReportFlow(),
    fetchMonthlyScheduleChecklistReportFlow(),
    fetchWeeklyScheduleChecklistReportFlow(),
    fetchQuarterlyScheduleChecklistReportFlow(),
    fetchAnnualScheduleChecklistReportFlow(),
    fetchBiannualScheduleChecklistReportFlow(),
    exportMonthlyScheduleChecklistReportFlow(),
    exportWeeklyScheduleChecklistReportFlow(),
    exportQuarterlyScheduleChecklistReportFlow(),
    exportAnnualScheduleChecklistReportFlow(),
    exportBiannualScheduleChecklistReportFlow(),
    fetchDailyScheduleChecklistReportFlow(),
    updateInspectionStatusFlow(),
    approveInspectionFlow(),
    skipInspectionItemsFlow(),
    editMaintenanceInspectionFlow(),
  ]);
}
